
import { Stack } from "@mui/material";
import PropTypes from "prop-types";
import MaterialBox from "../../../MaterialBox";
import breakpoints from "../../../../assest/theme/base/breakpoints";

const SliderIndicator = ({ sliderItems, currentItem, moveToASpecificItem }) => {
    return (
        <MaterialBox style={{
            textAlign: 'center', position: 'absolute', bottom:
                window.innerWidth < breakpoints.values.md ? '4%' :
                    window.innerWidth < breakpoints.values.lg ? '6%' :
                        '10%'
            , left: '50%', transform: 'translateX(-50%)',
        }}>
            <Stack direction="row" spacing={1}>
                {
                    sliderItems.map((item, index) => (
                        <MaterialBox
                            key={index}
                            style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                backgroundColor: currentItem === index ? '#000' : 'darkgray',
                                cursor: 'pointer',
                            }}
                            onClick={() => moveToASpecificItem(item.id)}
                        />
                    ))
                }
            </Stack>
        </MaterialBox>

    )
}

SliderIndicator.propTypes = {
    sliderItems: PropTypes.array,
    currentItem: PropTypes.number,
    moveToASpecificItem: PropTypes.func.isRequired,
}

SliderIndicator.defaultProps = {
    sliderItems: [],
    currentItem: 0,
    moveToASpecificItem: () => { },
}

export default SliderIndicator;